export const containerStyles = {
  marginBottom: '$4',
  marginTop: '$2'
}

export const gridStyles = {
  gridTemplateColumns: '1fr 1fr',
  gap: '$4',
  marginBottom: '$2'
}

export const textareaStyles = {
  minHeight: '60px',
  resize: 'vertical'
}

export const characterCounterStyles = {
  marginTop: '$1',
  textAlign: 'right',
  fontSize: '$caption',
  color: '$medium-medium',
  display: 'block'
}

export const deleteButtonStyles = {
  borderColor: 'none',
  width: '150px'
}
